import mergeToNew from "@insite/client-framework/Common/mergeToNew";
import StyledWrapper from "@insite/client-framework/Common/StyledWrapper";
import { HasProduct, withProduct } from "@insite/client-framework/Components/ProductContext";
import siteMessage from "@insite/client-framework/SiteMessage";
import translate from "@insite/client-framework/Translate";
import Link from "@insite/mobius/Link";
import Typography, { TypographyProps } from "@insite/mobius/Typography";
import * as React from "react";
import { css } from "styled-components";

export interface ReplacementProductLinkStyles {
    labelText?: TypographyProps;
    valueText?: TypographyProps;
}

export const replacementPartNumberStyles: ReplacementProductLinkStyles = {
    labelText: {
        size: 16,
        weight: "bold",
        css: css`
            margin-right: 15px;
        `,
    },
    valueText: {
        size: 16,
        css: css`
            margin-bottom: 5px;
        `,
    },
};

interface OwnProps {
    extendedStyles?: ReplacementProductLinkStyles;
}

type Props = HasProduct & OwnProps;

const ReplacementProductLink: React.FC<Props> = ({ product, extendedStyles }) => {
    if (!product || !product.replacementProductUrl) {
        return null;
    }
    const [styles] = React.useState(() => mergeToNew(replacementPartNumberStyles, extendedStyles));
    return (
        <StyledWrapper {...styles.valueText} data-test-selector="ReplacementProductNumber">
            <Typography {...styles.labelText} as="div">
                {product.properties["replacementProductNumber"] !== ""
                    ? siteMessage("Item_Discontinued_Message", "abc")
                    : ""}
            </Typography>
            <StyledWrapper>
                <Typography {...styles.labelText}>{translate("Replacement Part Number")}</Typography>
                <Typography>{product.properties["replacementProductNumber"]}</Typography>
            </StyledWrapper>
            <StyledWrapper>
                <Typography {...styles.labelText}>{translate("Replacement Part")}</Typography>
                <Link href={product.replacementProductUrl ?? ""}>
                    {product.replacementProductShortDescription ?? product.replacementProductUrl}
                </Link>
            </StyledWrapper>
        </StyledWrapper>
    );
};

export default withProduct(ReplacementProductLink);
